export default __webpack_public_path__ + "static/media/like.caec3eb0.svg";